import type { FileRecord } from "@/models/club";
import moment from "moment-jalaali";
import React, { useMemo } from "react";
import { getPartnerDayEvents, getShiftHours } from "./helper/helper";
import { TimeGrid, TimeGridColumn } from "./TimeGrid";
import { CalendarViewProps } from "./types";
import UserHeader from "./UserHeader";

// Stable empty object so UserHeader never gets a new fileRecord reference when image is missing
const EMPTY_FILE_RECORD: FileRecord = {};

const DayView = ({ currentDate, partners, onEmptySlotClick, onEventClick, shiftSchedule, setSelectedEvent }: CalendarViewProps) => {
  const dateKey = currentDate?.format("YYYY-MM-DD");
  const isToday = !!currentDate && moment().isSame(currentDate, "day");

  // Events, overlap layout input and shift hours are prepared once per member and date.
  const columns = useMemo<TimeGridColumn[]>(() => {
    const date = currentDate || moment();
    return (partners || []).map((partner, index) => ({
      key: `member-${partner?.user?.id ?? index}`,
      partner,
      date,
      isToday,
      events: getPartnerDayEvents(partner?.appointmentCalendar || [], date, partner),
      shiftsByHour: getShiftHours(shiftSchedule || [], date, partner.user?.id),
    }));
  }, [partners, currentDate, shiftSchedule, isToday]);

  // Headers only depend on the members, not on the date.
  const headers = useMemo(() => (partners || []).map((partner) => (
    <UserHeader
      fileRecord={partner?.user?.image ?? EMPTY_FILE_RECORD}
      firstName={partner?.user?.firstName ?? ""}
      lastName={partner?.user?.lastName ?? ""}
      color={partner?.user?.calendarColor ?? ""}
      id={partner?.user?.id ?? 0}
    />
  )), [partners]);

  return (
    <TimeGrid
      columns={columns}
      headers={headers}
      scrollKey={`${dateKey}-${partners?.length || 0}`}
      onEmptySlotClick={onEmptySlotClick}
      onEventClick={onEventClick}
      setSelectedEvent={setSelectedEvent}
    />
  );
};

const MemoDayView = React.memo(DayView);
export default MemoDayView;
